import {
  Building2,
  Home,
  Map,
  Store,
  Heart,
  Search,
  PlusCircle,
  User,
  Menu,
  X,
  AlertTriangle,
  Download,
  Trash2,
  Edit2,
  MapPin,
  Phone,
  Mail,
  Share2,
  LogOut,
  LogIn,
  UserPlus,
  FileText,
  LayoutDashboard,
  InfoIcon,
  Send,
  MessageCircle,
} from 'lucide-react';

import {
  FaTiktok,
  FaTelegramPlane,
  FaFacebook,
  FaInstagram,
} from 'react-icons/fa';

type IconName = string;

interface IconProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
}

export const iconMap: Record<IconName, React.ComponentType<any>> = {
  // Categories
  Building2,
  Home,
  Map,
  Store,

  // Navigation
  Heart,
  Search,
  PlusCircle,
  User,
  Menu,
  X,
  LogOut,
  LogIn,
  UserPlus,
  FileText,
  LayoutDashboard,
  InfoIcon,

  // Actions
  AlertTriangle,
  Download,
  Trash2,
  Edit2,
  MapPin,
  Phone,
  Mail,
  Share2,
  Send,

  // Social
  Instagram: FaInstagram,
  Facebook: FaFacebook,
  Telegram: FaTelegramPlane,
  TikTok: FaTiktok,
  WhatsApp: MessageCircle,
};

export const getIcon = (iconName: string, props?: IconProps) => {
  const IconComponent = iconMap[iconName];

  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found`);
    return null;
  }

  return <IconComponent {...(props || {})} />;
};
